import { CounterDetail } from "./CounterDetail.js";

export interface CountersDetail {
    counters: CounterDetail[];
}
